/** `agentTeams` namespace dictionaries for every plugin-owned Web surface. */
/** Dictionary namespace owned by the AgentTeams client plugin. */
export const AGENT_TEAMS_LOCALE_NAMESPACE = 'agentTeams';
/** Simplified Chinese dictionary (the key-set source of truth). */
export const zh = {
    'card.memberCount': '{count} 名成员',
    'action.openActivityPanel': '打开活动面板',
    'activity.panelButton': '活动面板',
    'activity.badgeAria': 'AgentTeams 活动与历史，{count} 条团队记录',
    'activity.panelAria': 'AgentTeams 活动面板',
    'activity.title': 'AgentTeams 活动',
    'activity.float': '切换为浮动面板',
    'activity.dockRight': '停靠到右侧',
    'activity.collapse': '收起活动面板',
    'activity.empty': '暂无团队活动',
    'team.stop': '停止团队',
    'team.stopped': '已停止',
    'team.stopTitle': '确认停止“{team}”？',
    'team.stopDescription': '将取消 {tasks} 项未完成任务，并停止 {members} 名正在工作的成员。已完成的结果会保留。',
    'team.stopCancel': '继续运行',
    'team.stopConfirm': '确认停止',
    'team.stopping': '正在停止…',
    'team.stopFailed': '停止失败：{message}',
    'team.stopRequestFailed': '服务器未能停止团队，请重试',
    'team.discarded': '已放弃',
    'format.listSeparator': '、',
    'task.status.pending': '待领取',
    'task.status.claimed': '已认领',
    'task.status.inProgress': '进行中',
    'task.status.completed': '已完成',
    'task.status.failed': '失败',
    'task.status.cancelled': '已取消',
    'task.status.notRun': '未执行',
    'member.state.working': '工作中',
    'member.state.failed': '有失败',
    'member.state.waiting': '等待',
    'member.state.delivered': '已交付',
    'member.state.left': '已离队',
    'member.state.removed': '已移除',
    'member.state.pending': '待执行',
    'member.state.unassigned': '待派工',
    'member.state.staged': '待创建',
    'member.state.notCreated': '未创建',
    'member.state.stopped': '已停止',
    'member.status.executing': '正在执行 {taskId}',
    'member.status.executingModel': '正在执行 {taskId} · {model}',
    'member.status.working': '正在处理已派任务',
    'member.status.waitingOn': '等待 {taskId} · {assignee}',
    'member.status.waitingPrerequisite': '等待前置任务',
    'member.status.waitingAssignment': '等待队长派工',
    'member.status.delivered': '任务已交付',
    'member.status.idle': '待继续执行',
    'member.status.unknown': '状态未知',
    'member.status.staged': '确认后创建并启动',
    'member.status.settled': '任务均已终结',
    'member.status.discarded': '计划已放弃，未创建',
    'member.status.stopped': '团队已停止，需显式恢复',
    'task.assignee.unclaimed': '待认领',
    'task.summary.waitingBreakdown': '等待队长拆解任务',
    'task.summary.staged': '{count} 项计划等待确认',
    'task.summary.discarded': '{count} 项计划已放弃，均未执行',
    'task.summary.allDelivered': '全部 {count} 项任务已交付',
    'task.summary.ended': '终态：{completed} 已交付 · {cancelled} 已取消 · {failed} 失败',
    'task.summary.blockedAndRunning': '{tasks}{more} 等待前置，其余已开工',
    'task.summary.more': ' 等 {count} 项',
    'task.summary.running': '{tasks} 正在执行',
    'task.summary.ready': '{tasks} 已就绪待开工',
    'task.summary.blocked': '{tasks} 等待前置',
    'task.summary.failedSettled': '{count} 项已失败，自动循环已停止',
    'task.summary.waitingSchedule': '等待下一轮调度',
    'progress.aria': '团队总进度',
    'progress.title': '总进度',
    'progress.running': '■ 进行中 {count}',
    'progress.blocked': '■ 等待依赖 {count}',
    'progress.delivered': '■ 已交付 {count}',
    'dependency.aria': '任务依赖链',
    'dependency.parallel': '并行任务',
    'dependency.title': '任务依赖',
    'dependency.hint.parallel': '无前后依赖 · 点击查看详情',
    'dependency.hint.chain': '悬停高亮依赖链 · 点击固定',
    'dependency.hint.pinned': '{taskId} 已固定 · Esc 取消',
    'task.runningAria': '运行中',
    'task.model': '{model}',
    'task.detail.completed': '已完成并交付',
    'task.detail.noPrerequisite': '无前置，可立即开工',
    'task.detail.ready': '前置已就绪，可开工',
    'task.detail.waitingOn': '等待 {tasks}',
    'task.detail.notRun': '计划已放弃，任务未执行',
    'task.detail.noDownstream': '无下游任务',
    'task.detail.unlocks': '完成后解锁 {tasks}',
    'team.ended': '已结束',
    'plan.badge': '待确认',
    'plan.title': '执行前计划审查',
    'plan.description': '成员尚未创建、任务尚未调度。可直接调整计划，也可返回对话告诉队长哪里需要修改。',
    'plan.member.role': '角色',
    'plan.member.provider': 'Provider',
    'plan.member.model': '模型',
    'plan.member.reasoning': '推理等级',
    'plan.member.reasoningHint': '留空使用默认值；可用 low、medium、high、xhigh 等',
    'plan.model.choose': '选择模型',
    'plan.model.currentUnavailable': '{provider}/{model}（当前目录不可用）',
    'plan.model.route': '路由：{provider}/{model}',
    'plan.model.defaultReasoning': '默认推理等级',
    'plan.model.providerDefault': 'Provider 默认值',
    'plan.model.modelDefault': '模型默认值（{effort}）',
    'plan.model.triggerAria': '选择成员模型，当前 {model}，推理等级 {effort}',
    'plan.model.back': '返回',
    'plan.model.loading': '正在加载模型…',
    'plan.model.empty': '暂无可用模型',
    'plan.model.partialFailure': '{count} 个 Provider 的模型目录加载失败',
    'plan.model.retry': '重试',
    'plan.member.prompt': '角色提示词',
    'plan.member.roleFallback': '未设置角色',
    'plan.task.subject': '任务名称',
    'plan.task.description': '任务说明',
    'plan.task.assignee': '负责人',
    'plan.task.dependencies': '依赖任务 ID（逗号分隔）',
    'plan.task.dependenciesHint': '例如 task-1, task-2；不得形成循环依赖',
    'plan.task.unassigned': '共享任务池',
    'plan.unsaved': '未保存',
    'plan.save': '保存',
    'plan.saving': '保存中…',
    'plan.remove': '删除',
    'plan.removed': '任务已删除',
    'plan.removeConfirm': '确认删除',
    'plan.removeWarning': '删除 {task} 后将重新计算依赖关系。',
    'plan.cancel': '取消',
    'plan.addTask': '添加任务',
    'plan.adding': '添加中…',
    'plan.taskAdded': '任务已添加',
    'plan.newTask': '新任务名称',
    'plan.newTaskLabel': '新增计划任务',
    'plan.readySummary': '{members} 名成员 · {tasks} 项任务 · {links} 条依赖',
    'plan.flow.aria': '团队启动流程',
    'plan.flow.review': '审查计划',
    'plan.flow.spawn': '创建成员',
    'plan.flow.run': '开始执行',
    'plan.members.title': '成员与模型路由',
    'plan.members.count': '{count} 名成员',
    'plan.members.empty': '尚未规划成员',
    'plan.tasks.title': '任务与依赖',
    'plan.tasks.count': '{count} 项任务 · {links} 条依赖',
    'plan.tasks.empty': '尚未规划任务',
    'plan.dependencies.none': '无依赖',
    'plan.dependencies.count': '{count} 条依赖',
    'plan.approve': '确认并启动团队',
    'plan.approving': '正在创建成员…',
    'plan.approveTitle': '计划检查完毕？',
    'plan.approveHint': '确认后将创建 {members} 名成员并调度 {tasks} 项任务。',
    'plan.approveConfirmTitle': '确认启动此团队',
    'plan.approveWarning': '启动后不能再在此处编辑成员和依赖。',
    'plan.approveConfirm': '确认启动',
    'plan.continue': '返回对话修改',
    'plan.returnToChat': '回到对话',
    'plan.feedbackTitle': '正在等你说明修改方向',
    'plan.feedbackHint': '队长会在对话中追问；收到你的回复后，只修改这份草案并再次等待确认。',
    'plan.discard': '放弃本次计划',
    'plan.discardConfirmTitle': '放弃本次计划？',
    'plan.discardWarning': '该计划会结束并归档；尚未创建任何成员，也不会执行任务。',
    'plan.discardConfirm': '确认放弃',
    'plan.discarding': '正在放弃…',
    'plan.pendingEdits': '请先保存当前修改，再启动团队。',
    'plan.saved': '计划已保存',
    'plan.failed': '操作失败：{message}',
    'team.stats.members': '{count} 名成员',
    'team.stats.completed': '{completed}/{total} 完成',
    'team.stats.messages': '{count} 条消息',
    'delegation.aria': '队长派工关系',
    'captain.name': '队长',
    'captain.role': '拆解 · 派发 · 汇总',
    'captain.summary': '已派发 {tasks} 项任务给 {members} 名成员',
    'captain.summary.staged': '已规划 {tasks} 项任务与 {members} 名成员，等待确认',
    'captain.summary.awaitingFeedback': '草案已保留，等待你在对话中说明修改方向',
    'captain.summary.discarded': '计划已放弃：{members} 名成员未创建，{tasks} 项任务未执行',
    'captain.summary.withTakeover': '已派发 {tasks} 项给成员 · 队长接管 {captainTasks}',
    'captain.state.working': '{count} 人执行中',
    'captain.state.takeover': '正在执行 {tasks}',
    'captain.state.collected': '已收齐',
    'captain.state.waiting': '等待回报',
    'captain.state.staged': '待确认',
    'captain.state.awaitingFeedback': '待反馈',
    'captain.state.discarded': '已放弃',
    'captain.state.settled': '已终结',
    'members.toggle': '{count} 名成员',
    'members.collapse': '收起',
    'members.expand': '展开',
    'members.empty': '暂无成员，等待队长组建团队',
    'assignment.label': '队长派发',
    'assignment.staged': '计划任务',
    'assignment.discarded': '未执行的计划',
    'assignment.empty': '暂无任务',
    'archive.label': '已结束 · 历史归档',
    'archive.discardedLabel': '计划已放弃 · 历史归档',
};
/** English dictionary, checked complete against the Chinese source key set. */
export const en = {
    'card.memberCount': '{count} members',
    'action.openActivityPanel': 'Open activity panel',
    'activity.panelButton': 'Activity panel',
    'activity.badgeAria': 'AgentTeams activity and history, {count} team records',
    'activity.panelAria': 'AgentTeams activity panel',
    'activity.title': 'AgentTeams activity',
    'activity.float': 'Switch to floating panel',
    'activity.dockRight': 'Dock to the right',
    'activity.collapse': 'Collapse activity panel',
    'activity.empty': 'No team activity',
    'team.stop': 'Stop team',
    'team.stopped': 'Stopped',
    'team.stopTitle': 'Stop “{team}”?',
    'team.stopDescription': 'This cancels {tasks} unfinished tasks and stops {members} working members. Completed results are kept.',
    'team.stopCancel': 'Keep running',
    'team.stopConfirm': 'Stop team',
    'team.stopping': 'Stopping…',
    'team.stopFailed': 'Could not stop team: {message}',
    'team.stopRequestFailed': 'The server could not stop this team. Try again.',
    'team.discarded': 'Discarded',
    'format.listSeparator': ', ',
    'task.status.pending': 'Unclaimed',
    'task.status.claimed': 'Claimed',
    'task.status.inProgress': 'In progress',
    'task.status.completed': 'Completed',
    'task.status.failed': 'Failed',
    'task.status.cancelled': 'Cancelled',
    'task.status.notRun': 'Not run',
    'member.state.working': 'Working',
    'member.state.failed': 'Has failures',
    'member.state.waiting': 'Waiting',
    'member.state.delivered': 'Delivered',
    'member.state.left': 'Left team',
    'member.state.removed': 'Removed',
    'member.state.pending': 'Pending',
    'member.state.unassigned': 'Awaiting assignment',
    'member.state.staged': 'Not spawned',
    'member.state.notCreated': 'Not created',
    'member.state.stopped': 'Stopped',
    'member.status.executing': 'Working on {taskId}',
    'member.status.executingModel': 'Working on {taskId} · {model}',
    'member.status.working': 'Working on assigned tasks',
    'member.status.waitingOn': 'Waiting for {taskId} · {assignee}',
    'member.status.waitingPrerequisite': 'Waiting for prerequisites',
    'member.status.waitingAssignment': 'Waiting for the captain to assign work',
    'member.status.delivered': 'Tasks delivered',
    'member.status.idle': 'Ready to continue',
    'member.status.unknown': 'Status unknown',
    'member.status.staged': 'Will be spawned after approval',
    'member.status.settled': 'All assigned work is settled',
    'member.status.discarded': 'Plan discarded; member was not created',
    'member.status.stopped': 'Team stopped; explicit resume required',
    'task.assignee.unclaimed': 'Unclaimed',
    'task.summary.waitingBreakdown': 'Waiting for the captain to break down the work',
    'task.summary.staged': '{count} planned tasks awaiting approval',
    'task.summary.discarded': '{count} planned tasks discarded; none ran',
    'task.summary.allDelivered': 'All {count} tasks delivered',
    'task.summary.ended': 'Final: {completed} delivered · {cancelled} cancelled · {failed} failed',
    'task.summary.blockedAndRunning': '{tasks}{more} waiting on prerequisites; other work has started',
    'task.summary.more': ' and {count} more',
    'task.summary.running': '{tasks} in progress',
    'task.summary.ready': '{tasks} ready to start',
    'task.summary.blocked': '{tasks} waiting on prerequisites',
    'task.summary.failedSettled': '{count} failed; the automatic loop has stopped',
    'task.summary.waitingSchedule': 'Waiting for the next scheduling round',
    'progress.aria': 'Overall team progress',
    'progress.title': 'Overall progress',
    'progress.running': '■ In progress {count}',
    'progress.blocked': '■ Waiting {count}',
    'progress.delivered': '■ Delivered {count}',
    'dependency.aria': 'Task dependency chain',
    'dependency.parallel': 'Parallel tasks',
    'dependency.title': 'Task dependencies',
    'dependency.hint.parallel': 'No dependencies · Click for details',
    'dependency.hint.chain': 'Hover to highlight dependencies · Click to pin',
    'dependency.hint.pinned': '{taskId} pinned · Esc to clear',
    'task.runningAria': 'Running',
    'task.model': '{model}',
    'task.detail.completed': 'Completed and delivered',
    'task.detail.noPrerequisite': 'No prerequisites; ready to start',
    'task.detail.ready': 'Prerequisites ready; can start',
    'task.detail.waitingOn': 'Waiting for {tasks}',
    'task.detail.notRun': 'Plan discarded; task was not run',
    'task.detail.noDownstream': 'No downstream tasks',
    'task.detail.unlocks': 'Unlocks {tasks} when complete',
    'team.ended': 'Ended',
    'plan.badge': 'Awaiting approval',
    'plan.title': 'Pre-run plan review',
    'plan.description': 'Members have not been spawned and tasks have not been scheduled. Edit the draft here, or return to chat and tell the Captain what should change.',
    'plan.member.role': 'Role',
    'plan.member.provider': 'Provider',
    'plan.member.model': 'Model',
    'plan.member.reasoning': 'Reasoning effort',
    'plan.member.reasoningHint': 'Leave blank for default; accepts low, medium, high, xhigh, and more',
    'plan.model.choose': 'Choose a model',
    'plan.model.currentUnavailable': '{provider}/{model} (not in the current catalog)',
    'plan.model.route': 'Route: {provider}/{model}',
    'plan.model.defaultReasoning': 'Default reasoning effort',
    'plan.model.providerDefault': 'Provider default',
    'plan.model.modelDefault': 'Model default ({effort})',
    'plan.model.triggerAria': 'Choose member model, currently {model}, reasoning effort {effort}',
    'plan.model.back': 'Back',
    'plan.model.loading': 'Loading models…',
    'plan.model.empty': 'No models available',
    'plan.model.partialFailure': '{count} provider catalogs could not be loaded',
    'plan.model.retry': 'Retry',
    'plan.member.prompt': 'Role prompt',
    'plan.member.roleFallback': 'Role not set',
    'plan.task.subject': 'Task subject',
    'plan.task.description': 'Task description',
    'plan.task.assignee': 'Assignee',
    'plan.task.dependencies': 'Dependency task IDs (comma-separated)',
    'plan.task.dependenciesHint': 'For example task-1, task-2; cycles are rejected',
    'plan.task.unassigned': 'Shared task pool',
    'plan.unsaved': 'Unsaved',
    'plan.save': 'Save',
    'plan.saving': 'Saving…',
    'plan.remove': 'Remove',
    'plan.removed': 'Task removed',
    'plan.removeConfirm': 'Confirm remove',
    'plan.removeWarning': 'Removing {task} will recalculate downstream dependencies.',
    'plan.cancel': 'Cancel',
    'plan.addTask': 'Add task',
    'plan.adding': 'Adding…',
    'plan.taskAdded': 'Task added',
    'plan.newTask': 'New task subject',
    'plan.newTaskLabel': 'Add a planned task',
    'plan.readySummary': '{members} members · {tasks} tasks · {links} dependencies',
    'plan.flow.aria': 'Team launch flow',
    'plan.flow.review': 'Review plan',
    'plan.flow.spawn': 'Create members',
    'plan.flow.run': 'Start work',
    'plan.members.title': 'Members & model routes',
    'plan.members.count': '{count} members',
    'plan.members.empty': 'No members planned yet',
    'plan.tasks.title': 'Tasks & dependencies',
    'plan.tasks.count': '{count} tasks · {links} dependencies',
    'plan.tasks.empty': 'No tasks planned yet',
    'plan.dependencies.none': 'No dependencies',
    'plan.dependencies.count': '{count} dependencies',
    'plan.approve': 'Approve & Run',
    'plan.approving': 'Creating members…',
    'plan.approveTitle': 'Plan ready?',
    'plan.approveHint': 'Approval creates {members} members and schedules {tasks} tasks.',
    'plan.approveConfirmTitle': 'Confirm team launch',
    'plan.approveWarning': 'Member routes and dependencies cannot be edited here after launch.',
    'plan.approveConfirm': 'Confirm launch',
    'plan.continue': 'Return to chat & revise',
    'plan.returnToChat': 'Return to chat',
    'plan.feedbackTitle': 'Waiting for your revision direction',
    'plan.feedbackHint': 'The Captain will ask in chat. After your reply, it will revise this draft and wait for approval again.',
    'plan.discard': 'Discard this plan',
    'plan.discardConfirmTitle': 'Discard this plan?',
    'plan.discardWarning': 'The plan will end and be archived. No members have been spawned and no tasks will run.',
    'plan.discardConfirm': 'Discard plan',
    'plan.discarding': 'Discarding…',
    'plan.pendingEdits': 'Save the current edits before launching the team.',
    'plan.saved': 'Plan saved',
    'plan.failed': 'Operation failed: {message}',
    'team.stats.members': '{count} members',
    'team.stats.completed': '{completed}/{total} completed',
    'team.stats.messages': '{count} messages',
    'delegation.aria': 'Captain delegation map',
    'captain.name': 'Captain',
    'captain.role': 'Break down · Delegate · Synthesize',
    'captain.summary': 'Assigned {tasks} tasks to {members} members',
    'captain.summary.staged': 'Planned {tasks} tasks and {members} members; awaiting approval',
    'captain.summary.awaitingFeedback': 'Draft preserved; waiting for your revision direction in chat',
    'captain.summary.discarded': 'Plan discarded: {members} members were not created and {tasks} tasks did not run',
    'captain.summary.withTakeover': 'Assigned {tasks} to members · Captain owns {captainTasks}',
    'captain.state.working': '{count} active',
    'captain.state.takeover': 'Working on {tasks}',
    'captain.state.collected': 'All reports received',
    'captain.state.waiting': 'Waiting for reports',
    'captain.state.staged': 'Awaiting approval',
    'captain.state.awaitingFeedback': 'Awaiting feedback',
    'captain.state.discarded': 'Discarded',
    'captain.state.settled': 'Settled',
    'members.toggle': 'Members {count}',
    'members.collapse': 'Collapse',
    'members.expand': 'Expand',
    'members.empty': 'No members yet; waiting for the captain to assemble the team',
    'assignment.label': 'Captain assigned',
    'assignment.staged': 'Planned task',
    'assignment.discarded': 'Plan not run',
    'assignment.empty': 'No tasks',
    'archive.label': 'Ended · Archived history',
    'archive.discardedLabel': 'Plan discarded · Archived history',
};
